<template>
  <HeroSection v-if="showHeroSection"></HeroSection>

  <div class="main-homepage-content container-xxl">
    <LessonGeneration @update-hero-section="updateHeroSection" />
    <LessonLibrary />
    <StudentReview />
  </div>

  <ConfirmationModal
    v-model="showMergedAccountModal"
    title="Confirmation"
    message="This email is already associated with an existing account."
    confirmText="OK"
    :hideCancel="true"
    @confirm="handleModalClose"
    @cancel="handleModalClose"
  />
</template>

<script setup>
import HeroSection from "@/components/homepage/HeroSection.vue";
import LessonGeneration from "@/components/homepage/LesssonGeneration.vue";
import LessonLibrary from "@/components/homepage/LessonLibrary.vue";
import StudentReview from "@/components/homepage/StudentReview.vue";
import ConfirmationModal from "@/components/common/ConfirmationModal.vue";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const showHeroSection = ref(true);

const updateHeroSection = (value) => {
  showHeroSection.value = value;
};

const route = useRoute();
const router = useRouter();
const showMergedAccountModal = ref(false);

onMounted(() => {
  if (route.query.isMergedAccount) {
    showMergedAccountModal.value = true;
  }
});

const handleModalClose = () => {
  showMergedAccountModal.value = false;
  // Remove query param
  const query = { ...route.query };
  delete query.isMergedAccount;
  router.replace({ query });
};
</script>

<style></style>

<style scoped>
.main-homepage-content {
  height: 100%;
  width: 100%;
  padding: 20px 0px;
  backdrop-filter: blur(50px);
  scroll-behavior: smooth;
}

@media (max-width: 480px) {
  :deep(.action-button__text) {
    font-size: var(--fs-small);
  }
}
</style>
